module.exports = __webpack_public_path__ + "static/nbc-logo-banner-9eb821b7e7534f9f4aadbfcbc4efb538.png";